
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    CircularProgress,
    Divider,
    Skeleton
} from '@mui/material'

const ShrimpTopupCardViewTopupSkeleton = () => {
    return (
        <>
            <Card sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: { xs: 1, sm: 2 },
                boxShadow: { xs: 1, sm: 2 },
            }}>
                <CardContent sx={{
                    p: { xs: 1.5, sm: 2 }
                }}>
                    <Box sx={{ mb: 2 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider sx={{ my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider sx={{ my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="text" width="100%" />
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default ShrimpTopupCardViewTopupSkeleton